var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-manage-related-event-container" }, [
    _c("div", { staticClass: "choose-events-section" }, [
      _c("div", { staticClass: "section-title h4-text" }, [
        _vm._v("Find Events")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field-input-wrapper mt-2" }, [
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "b-input-group",
              [
                _c("b-form-input", {
                  staticClass: "placeholder-italic input-search-event",
                  class: { marginTop6px: _vm.fixElement },
                  attrs: {
                    type: "text",
                    placeholder: "Search for events",
                    formatter: _vm.format
                  },
                  model: {
                    value: _vm.textSearch,
                    callback: function($$v) {
                      _vm.textSearch = $$v
                    },
                    expression: "textSearch"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "search-icon" })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-events remove-margin-side margin-side" }, [
        _c("div", { staticClass: "list-header mb-3" }, [
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-30" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Shipping Address")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Onsite Contact")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _vm.isSearchLoading
          ? _c(
              "div",
              { staticClass: "list-loading d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Spinning" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSearchLoading
          ? _c(
              "div",
              _vm._l(_vm.eventsAvailable, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "list-container" },
                  [
                    _c("div", { staticClass: "list-content" }, [
                      _c("div", { staticClass: "column width-20" }, [
                        _c(
                          "div",
                          { staticClass: "container-column border-seperate" },
                          [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-20" }, [
                        _c(
                          "div",
                          { staticClass: "container-column border-seperate" },
                          [_c("p", [_vm._v(_vm._s(item.eventName))])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-30" }, [
                        _c(
                          "div",
                          { staticClass: "container-column border-seperate" },
                          [
                            _c("div", { staticClass: "text-icon" }, [
                              _c("p", [_vm._v(_vm._s(item.shippingAddress))])
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-20" }, [
                        _c("div", { staticClass: "container-column" }, [
                          _c("div", { staticClass: "text-icon" }, [
                            _c("p", [_vm._v(_vm._s(item.contactName))])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column width-10" }, [
                        _c("div", { staticClass: "container-column" }, [
                          item.relatedStatus
                            ? _c("div", { staticClass: "added" }, [
                                _vm._v("Added")
                              ])
                            : _c(
                                "div",
                                {
                                  staticClass: "icon-add-wrapper",
                                  on: {
                                    click: function($event) {
                                      _vm.addEventRelated(item)
                                    }
                                  }
                                },
                                [_c("div", { staticClass: "icon-add" })]
                              )
                        ])
                      ])
                    ])
                  ]
                )
              })
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "added-events-section" }, [
      _c("div", { staticClass: "section-title h4-text" }, [
        _vm._v("\n      Related Events\n      "),
        _vm.relatedEvents.length >= 0
          ? _c("span", { staticClass: "ml-1" }, [
              _vm._v("(" + _vm._s(_vm.relatedEvents.length + 1) + ")")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-title h5-text mt-3" }, [
        _vm._v("\n      Related Events Title\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field-input-wrapper mt-2" }, [
        _c(
          "div",
          { staticClass: "input-wrapper" },
          [
            _c(
              "b-input-group",
              [
                _c("b-form-input", {
                  staticClass: "placeholder-italic input-search-event",
                  class: { marginTop6px: _vm.fixElement },
                  attrs: {
                    type: "text",
                    placeholder:
                      "Enter the title for your group of related events",
                    formatter: _vm.format
                  },
                  model: {
                    value: _vm.groupName,
                    callback: function($$v) {
                      _vm.groupName = $$v
                    },
                    expression: "groupName"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-events remove-margin-side margin-side" }, [
        _c("div", { staticClass: "list-header mb-3" }, [
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-30" }, [
            _c(
              "div",
              { staticClass: "container-column border-seperate" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Shipping Address")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column width-20" }, [
            _c(
              "div",
              { staticClass: "container-column" },
              [
                _c("p", { staticClass: "text-header" }, [
                  _vm._v("Onsite Contact")
                ]),
                _vm._v(" "),
                _c("b-button", { on: { click: _vm.onSort } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/arrow-down.svg"),
                      alt: "icon"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            [
              _c("div", { staticClass: "list-container" }, [
                _c("div", { staticClass: "list-content" }, [
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(_vm.currentEvent.prefDate))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(_vm.currentEvent.eventName))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-30" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [
                        _c("p", [
                          _vm._v(_vm._s(_vm.currentEvent.shippingAddress))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c("div", { staticClass: "container-column" }, [
                      _c("p", [_vm._v(_vm._s(_vm.currentEvent.contactName))])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ])
            ],
            _vm._v(" "),
            _vm._l(_vm.relatedEvents, function(item, index) {
              return _c("div", { key: index, staticClass: "list-container" }, [
                _c("div", { staticClass: "list-content" }, [
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [_c("p", [_vm._v(_vm._s(item.eventName))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-30" }, [
                    _c(
                      "div",
                      { staticClass: "container-column border-seperate" },
                      [
                        _c("div", { staticClass: "text-icon" }, [
                          _c("p", [_vm._v(_vm._s(item.shippingAddress))])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-20" }, [
                    _c("div", { staticClass: "container-column" }, [
                      _c("div", { staticClass: "text-icon" }, [
                        _c("p", [_vm._v(_vm._s(item.contactName))])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column width-10" }, [
                    _c("div", { staticClass: "container-column" }, [
                      _c(
                        "div",
                        {
                          staticClass: "icon-close-wrapper",
                          on: {
                            click: function($event) {
                              _vm.removeEventRelated(item)
                            }
                          }
                        },
                        [_c("div", { staticClass: "icon-close" })]
                      )
                    ])
                  ])
                ])
              ])
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "group-btn" }, [
      _c(
        "button",
        {
          staticClass: "ap-btn primary",
          attrs: { disabled: _vm.disableBtnSave },
          on: { click: _vm.saveRelatedEvents }
        },
        [_vm._v("Save")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column width-10" }, [
      _c("div", { staticClass: "container-column" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column width-10" }, [
      _c("div", { staticClass: "container-column" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column width-10" }, [
      _c("div", { staticClass: "container-column" }, [
        _c("p", { staticClass: "selected-text" }, [_vm._v("Selected Event")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65072ff3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65072ff3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/ManageRelatedEvents.vue
// module id = 1668
// module chunks = 1